import { render, staticRenderFns } from "./virtualSelector.vue?vue&type=template&id=f4923020"
import script from "./virtualSelector.vue?vue&type=script&lang=js"
export * from "./virtualSelector.vue?vue&type=script&lang=js"
import style0 from "./virtualSelector.vue?vue&type=style&index=0&id=f4923020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports